import React, { useEffect, useState } from 'react';
import { ShieldCheckIcon, ZapIcon } from 'lucide-react';
export function StickyCTABar() {
  const [scrolledPast, setScrolledPast] = useState(false);
  const [nearCta, setNearCta] = useState(false);
  useEffect(() => {
    const handleScroll = () => setScrolledPast(window.scrollY > 720);
    handleScroll();
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    const blocks = Array.from(document.querySelectorAll<HTMLElement>('[data-cta-block]'));
    if (blocks.length === 0) return;
    const visibleBlocks = new Set<Element>();
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) visibleBlocks.add(entry.target);else visibleBlocks.delete(entry.target);
      });
      setNearCta(visibleBlocks.size > 0);
    }, {
      threshold: 0
    });
    blocks.forEach(block => observer.observe(block));
    return () => observer.disconnect();
  }, []);
  const visible = scrolledPast && !nearCta;
  return <div className={`fixed inset-x-0 bottom-0 z-40 border-t-4 border-emerald-400 bg-[#241322] transition-transform duration-200 ease-out ${visible ? 'translate-y-0' : 'translate-y-full'}`} aria-hidden={!visible} data-id="element-249" data-mp="lwz4o4ysnpsj">
      
    </div>;
}